export * from './detalleInmuebleSlice';
export * from './thunks';